/**
 * The `/connect` command a dispatcher pastes into a driver's Telegram group to link it.
 *
 * Single source of the syntax: the bot parses it positionally as `/connect <projectName> <driverId>`
 * (see connect-command.ts in main-service), so every place that offers the command has to agree on
 * the exact shape — otherwise a format change silently leaves one surface handing out a command the
 * bot rejects. Returns an empty string when either id is missing, so callers can treat it as
 * "nothing to offer" without repeating the guard.
 */
export function buildTelegramConnectCommand(projectName?: string, driverId?: string): string {
    return projectName && driverId ? `/connect ${projectName} ${driverId}` : ''
}
